import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ user, onLogout }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header user={user} onLogout={onLogout} />

      <main className="flex-1 max-w-[1350px] mx-auto px-4 md:px-6 py-4 w-full">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
